<template>
  <div class="activeStep-container" :class="{ 'activeStep-container--flat': panelStyle !== 'default' }">
    <div class="activeStep mb-5" :class="{ 'activeStep--flat': panelStyle !== 'alternate' }">
      <!-- Top Row -->
      <div class="step-header space-between v-center">
        <div class="v-center">
          <img
            v-if="formTypeId === config.FORM_TEMPLATE_TYPE.JOF || panelStyle === 'alternate'"
            src="~@/assets/images/icons/arrow-back.svg"
            width="25"
            @click="$emit('goBack')"
            class="pointer mr-2"
          />
          <div v-overflow-tooltip class="step-name elipsis-text">
            {{ workflowData.workflow_stage?.name }}
          </div>
          <div class="mb-1 ml-2">
            <div
              :class="{
                'v-center workflowStatus status-tag': true,
                'not-started': workflowData?.state_value?.name === 'NOT_STARTED',
                'ongoing': workflowData?.state_value?.name === 'ONGOING',
                'completed': workflowData?.state_value?.name === 'COMPLETED',
                'cancelled': formStatus === config.FORM_STATE_MAP.CANCELLED ||  workflowData?.state_value?.name ===  config.WORKFLOW_STATE_NAMES.REJECTED
              }"
            >
              <span v-if="formStatus === config.FORM_STATE_MAP.CANCELLED">CANCELLED</span>
              <span v-else>{{ workflowData?.state_value?.name | statusfomat }}</span>
            </div>
          </div>
        </div>
        <div class="v-center">
          <!-- <button
            v-if="feature === config.CORE_FEATURES.TENANT &&  workflowData?.state_value?.name === 'REJECTED'"
            @click.stop="$emit('reOpenworkflow')"
            class="btn btn-2 v-center mr-1"
            v-tooltip="'Reopen Workflow'"
          >
          <img
                src="~@/assets/images/icons/undo-icon.svg"
                width="18px"
                height="18px"
                alt="Reopen Workflow"
              />
          </button> -->
          <button
            v-if="workflowData?.workflow_stage?.qc_parent_step_id"
            @click.stop="fillQC"
            class="fill-qc-btn mr-1"
          >
            {{ workflowData.editInstance ? 'Fill QC' : 'View QC' }}
          </button>
          <router-link
            :to="`/workflows/${workflowData?.workflow_version?.workflow_template.type_value?.name}/?version=${workflowData?.workflow_version?.id}&wfinstance=${wfInstanceId}`"
            target="_blank"
          >
            <button class="btn btn-2 v-center" v-tooltip="'View Workflow'">
              <img
                src="~@/assets/images/icons/workflows.svg"
                width="18px"
                height="18px"
                alt="View Workflow"
              />
            </button>
          </router-link>
        </div>
      </div>

      <!-- Cancellation Reason -->
      <div v-if="formStatus === config.FORM_STATE_MAP.CANCELLED">
        <span class="xs label">Reason for cancellation:</span>
        <div>{{ workflowData?.core_comments?.[0]?.comment ?? '--' }}</div>
      </div>

      <!-- Material Info for JOF -->
      <div
        v-if="formTypeId === config.FORM_TEMPLATE_TYPE.JOF && selectedMaterial.number"
        class="v-center space-between"
      >
        <div class="v-center">
          <div class="dept">Material :</div>
          <div class="date-value ml-1">
            {{ `${selectedMaterial?.name} #${selectedMaterial.number}` }}
          </div>
        </div>
        <div v-if="workflowData?.workflow_stage?.qc_parent_step_id" class="v-center">
          <label class="dept">Checklist Status:</label>
          <div class="status-display">
            <div class="status-icon">
              <div
                :class="[
                  'status-circle',
                  getStatusClass({
                    value: workflowData?.workflow_stage?.current_step_transition_history?.[0]
                      ?.qc_form?.status
                  })
                ]"
              >
                <span class="status-symbol">{{
                  getStatusIcon({
                    value: workflowData?.workflow_stage?.current_step_transition_history?.[0]
                      ?.qc_form?.status
                  })
                }}</span>
              </div>
            </div>
            <span class="status-text">{{
              workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form
                ?.status | getQCStatusName
            }}</span>
          </div>
        </div>
      </div>

      <div class="flex v-venter">
        <div class="dept">Workflow Template :</div>
        <div class="date-value ml-1">
          {{ workflowTemplateName }}
        </div>
      </div>

      <!-- Department -->
      <div class="flex v-venter" v-if="workflowData?.state_value?.name !== 'COMPLETED'">
        <div class="dept">Department :</div>
        <div class="date-value ml-1">
          {{ workflowData.workflow_stage?.core_user_group?.name ?? '--' }}
        </div>
      </div>
      <!-- Sources -->
<div class="flex v-venter" v-if="workflowData?.state_value?.name !== 'COMPLETED' && feature===this.feature === config.CORE_FEATURES.MATERIAL">
        <div class="dept">Selected Source :</div>
        <div class="date-value ml-1">
          {{ workflowData.workflow_stage?.outsourced ? 'OutSourced' : 'In House' }}
        </div>
    </div>
      <!-- Assignees -->
      <div
        v-if="workflowData?.state_value?.name !== 'COMPLETED' && formattedIndependentUsers?.length"
        class="v-center"
      >
        <div class="dept">Assignees :</div>
        <div class="avatar-container flex ml-3">
          <avatar
            v-for="user in formattedIndependentUsers"
            :key="user.id"
            :user="user.assigned_user"
            :title="getUserTooltip(user.assigned_user)"
            style="margin-right: -9.5px"
          />
          <avatar
            v-if="formattedIndependentUsersExceededCount"
            style="margin-right: -13.5px"
            :exceeded-count="formattedIndependentUsersExceededCount"
            :title="formattedIndependentUsersExceededCount + ' ' + 'more'"
          />
        </div>
      </div>

      <div class="border"></div>

      <!-- Date/Duration Row -->
      <div class="date-row space-between">
        <div class="date-block">
          <div class="xs label">Start Date</div>
          <div class="flex v-center">
            <div class="date-detail mr-1">Expected : &nbsp;</div>
            <div class="date-value">
              {{
                workflowData.workflow_instance_steps?.[0]?.planned_start_date | genericFormatDate
              }}
            </div>
          </div>
          <div class="flex v-center">
            <div class="date-detail">Actual : &nbsp;</div>
            <div class="date-value">
              {{
                workflowData.workflow_stage?.current_step_transition_history[0]?.start_date
                  | genericFormatDate
              }}
            </div>
          </div>
        </div>

        <div class="duration-block" v-if="workflowData?.state_value?.name !== 'COMPLETED'">
          <div class="label-2">Duration</div>
          <div class="duration-value">{{ formattedDuration }}</div>
        </div>

        <div class="date-block">
          <div class="xs label">End Date</div>
          <div class="v-center">
            <div class="date-detail">Expected : &nbsp;</div>
            <div class="date-value">
              {{ workflowData.workflow_instance_steps?.[0]?.planned_end_date | genericFormatDate }}
            </div>
          </div>
          <div class="flex v-center">
            <div class="date-detail">Actual : &nbsp;</div>
            <div class="date-value">
              {{
                workflowData.workflow_stage?.current_step_transition_history[0].end_date
                  | genericFormatDate
              }}
            </div>
          </div>
        </div>
      </div>

      <!-- Document Component Slot -->
      <component
        v-if="documentField"
        :ref="documentField.field_id"
        :is="documentField.form_field.key + '_COMPONENT'"
        :upload="true"
        :formTypeId="formTypeId"
        :showUpload="workflowData?.workflow_stage?.trigger_actions && ['on_start', 'on_end'].includes(workflowData?.workflow_stage?.trigger_actions[0]?.trigger_timing)"
        :stepName="workflowData?.workflow_stage?.name"
        :data="documentField"
        mode="EDIT"
        :value="formValueData[documentField.field_id]"
        :viewOnly="!showUpdateFormBtn"
        @customChange="handleInputChange"
        @filesUploaded="revisionFilesUploaded"
      />
        <input
          ref="fileInput"
          type="file"
          multiple
          @change="onFilePicked"
          style="display: none"
          />

      <!-- Upload Section -->
      <div
        v-if="
          formTemplateTypeId !== 14 &&
          workflowData?.workflow_stage?.trigger_actions
        "
      >
        <div v-if="
          workflowData?.workflow_stage?.trigger_actions[0]?.trigger_timing === 'on_start'"
          :class="[
            'upload-header',
            { imp: workflowData?.workflow_stage?.trigger_actions?.[0]?.mandatory }
          ]"
        >
          <label class="label">Upload</label>
          <div class="next-action-line"></div>
        </div>
        <div class="upload-row"  v-if="instanceStepDocs.length || existingFiles.length || newFiles.length || this.workflowData?.workflow_stage?.trigger_actions[0]?.trigger_timing === 'on_start'">
          <div class="upload-box" v-if="workflowData.editInstance  && this.workflowData?.workflow_stage?.trigger_actions[0]?.trigger_timing === 'on_start'">
            <div class="label-2 weight-500">File Upload</div>
            <img src="~@/assets/images/icons/upload-icon.svg" class="upload-icon" />
            <button @click="triggerFilePicker" class="btn btn-2">Browse</button>
          </div>

          <!-- Uploaded Files List -->
          <div class="uploaded-files-box">
            <div class="uploaded-header">Uploaded Files</div>

            <div
              v-if="existingFiles.length || newFiles.length || instanceStepDocs?.length"
              class="uploaded-list"
            >
              <table class="w-100" style="border-collapse: collapse">
                <thead style="position: sticky; top: 0; background-color: white; z-index: 1">
                  <tr style="border-bottom: 1px solid #eee">
                    <th
                      style="
                        text-align: left;
                        padding: 6px 0;
                        font-size: var(--text-xs1);
                        font-weight: 500;
                        color: #333;
                        width: 70%;
                      "
                    >
                      File Name
                    </th>
                    <th
                      style="
                        text-align: left;
                        padding: 6px 0;
                        font-size: var(--text-xs1);
                        font-weight: 500;
                        color: #333;
                        width: 30%;
                      "
                    >
                      Step Name
                    </th>
                    <th
                      style="
                        text-align: left;
                        padding: 6px 0;
                        font-size: var(--text-xs1);
                        font-weight: 500;
                        color: #333;
                      "
                    >
                      Size
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Existing and new files -->
                  <tr
                    v-for="(file, index) in [...existingFiles, ...newFiles]"
                    :key="'current-' + index"
                    class="uploaded-file"
                    style="display: table-row; border-bottom: 1px solid #eee"
                  >
                    <td
                      class="file-name"
                      style="
                        padding: 6px 0;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 0;
                      "
                    >
                      {{ file?.file_name }}
                    </td>
                    <td class="step-name" style="padding: 6px 0">
                      <span
                        style="
                          display: inline-block;
                          background-color: #e8f5e8;
                          color: #4a7c59;
                          padding: 2px 8px;
                          border-radius: 12px;
                          font-size: var(--text-xs1);
                          font-weight: 500;
                        "
                        >Ongoing</span
                      >
                    </td>
                    <td class="file-status" style="padding: 6px 0">
                      <span v-if="file?.status === 'uploading'" class="loader"></span>
                      <span v-else-if="file?.status === 'failed'" class="error-text">failed</span>
                      <span style="font-size: 10px" v-else>{{ file?.size }}</span>
                    </td>
                  </tr>

                  <!-- Instance step documents -->
                  <template v-for="(stepData, stepIndex) in instanceStepDocs">
                    <tr
                      v-for="file in stepData.core_attachments"
                      :key="'step-' + stepIndex + '-file-' + file.id"
                      class="uploaded-file"
                      style="display: table-row; border-bottom: 1px solid #eee"
                    >
                      <td
                        class="file-name"
                        style="
                          padding: 6px 0;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          max-width: 0;
                        "
                      >
                        {{ file?.file_name }}
                      </td>
                      <td
                        class="step-name"
                        style="
                          padding: 6px 0;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          max-width: 0;
                        "
                      >
                        <span
                          style="
                            display: inline-block;
                            background-color: #f0f0f0;
                            color: #666;
                            padding: 2px 8px;
                            border-radius: 12px;
                            font-size: var(--text-xs1);
                            font-weight: 500;
                          "
                        >
                          {{ file.workflow_instance_step?.workflow_step?.name ?? '--' }}
                        </span>
                      </td>
                      <td class="file-status" style="padding: 6px 0; font-size: 10px">
                        {{ formatFileSize(file.file_size) ?? '--' }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div v-else class="no-files">No Files Attached</div>
          </div>
        </div>
      </div>
      <div class="border"></div>

      <!-- Resource Item -->
      <div class="imp" v-if="workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0 && workflowData.editInstance">
        <resource-selection-comp
          :open="true"
          :availableResources="availableResources"
          :selectedResources="selectedResources"
          @select="selectResources"
          @close="() => {}"
        />
      </div>

      <!-- Next Action -->
      <div class="next-action" v-if="!getStates && showNextAction">
        <div class="next-action-header">
          <span class="label">Next Action</span>
          <div class="next-action-line"></div>
        </div>
        <p class="next-action-desc mb-2">
          Please select the appropriate transition for the next step in the workflow.
        </p>
        <customDropdown
          :list="nextTransitionData || []"
          :selected="selectedNextActionObj"
          :compact="true"
          @select="onNextActionSelect"
        />
      </div>

      <!-- User Selection Slot -->
      <user-selection-for-wf
        v-if="showUserSelectionComp"
        :selectedStartingStep="nextStepData"
        :selectedUsers="existingUsers"
        :selectedUserGroup="selectedUserGroup"
        :enableChildTenants="showChildTenants"
        @handleUserSelection="handleUserSelection"
      />

      <!-- Next Step Info -->
      <div class="next-step" v-if="selectedNextAction">
        <div class="flex w-100 v-center">
          <div class="dept">Step Name :  &nbsp;</div>
          <h3 class="weight-500 m">{{ nextStepData?.name ?? '--' }}</h3>
        </div>

        <div class="flex space-between w-100 my-2">
          <div class="flex">
            <div class="date-detail">Department : &nbsp;</div>
            <span class="date-value">{{ nextStepData.core_user_group?.name ?? '--' }}</span>
          </div>
          <div class="flex">
            <div class="date-detail text-right">Duration : &nbsp;</div>
            <span class="date-value">{{ nextStepData.duration ?? '--' }} hours</span>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex-end" v-if="!getStates">
        <div v-if="showFinishWf">
          <button class="btn btn-black mr-4" @click="finishWorkflow">Finish WF</button>
        </div>
        <div class="flex-end" v-if="showWfSaveBtn ">
          <button class="btn pointer" @click="updateWorkflowMaterial(null)">Save</button>
        </div>
        <div class="flex-end mx-2" v-if="showCancelButton">
          <button class="btn pointer cancel-wf-btn" @click="cancelWorkflowModal = true">{{ feature=== config.CORE_FEATURES.TENANT ? 'Reject WF': 'Cancel WF' }}</button>
        </div>
      </div>
      <div v-if="getStates">
        <span class="dept">{{ feature === config.CORE_FEATURES.BOM ? 'BOM' : 'DOCUMENT' }} is in the checkout state and cannot be updated. </span>
      </div>
    </div>
         <modal
        :open="cancelWorkflowModal"
        @close="closeWorkflowModal"
        :title="feature=== config.CORE_FEATURES.TENANT? 'Reject Workflow':'Cancel Workflow'"
        >
        <div>
          <p class="my-2 " v-if="feature=== config.CORE_FEATURES.TENANT">This action would mark the collaborator status as rejected and prevent any vendor material association</p>
          <div class="input-group">
              <label class="key">Reason:</label>
              <textarea class="reason" v-model="cancelReason" />
            </div>
            <div class="flex-end s mt-2">
              <button class="btn btn-black" @click="closeWorkflowModal">Cancel</button>
              <button class="btn ml-2" @click="cancelWorkflow">Confirm</button>
              </div>
        </div>
      </modal>
      <qc-inspection-dialog
      v-if="showQCDialog"
      :qcTemplateId="qcData.qcTemplateId"
      :qcformId="qcData.qcformId"
      :stepName="qcData.stepName || '--'"
      :edit="qcData.edit"
      @save="onQCSave"
      @close="closeQCDialog"
      @showQCHistory="handleQCHistory"
    />

    <!-- QC History Dialog -->
    <qc-iteration-list-dialog
      v-if="showQCHistoryDialog"
      :iterations="stepHistory"
      :stepHistory="stepHistory"
      :stepId="qcData.step_id"
      :instanceId="qcData.instance_id"
      :showFillInspection="true"
      @close="closeQCHistoryDialog"
      @viewInspection="viewInspection"
      @updateQcform="updateQcform"
    />
  </div>
</template>

<script>
import { genericFormatDate } from '@/utils/date'
import customDropdown from '@/components/common/customDropdown.vue'
import Avatar from '@/components/common/avatar.vue'
import modal from '@/components/common/modal.vue'
import config from '@/config'
import { generateS3SubmittingUrl, getAllStepDocsExceptGivenStep, getNextStepWithTransitionId, getWfStepHistory, updateWorkFlowActionApi, workflowDataBasedOnInstanceId, updateResourceGroup, GetFormDataByFormId, getFactoryResourceAssociations } from '@/api'
import { alert, success } from '@/plugins/notification'
import { mapGetters } from 'vuex'
import Loader from '@/plugins/loader'
import { getStepAssignees } from '@/api/apis/workflows'
import UserSelectionForWf from '@/components/form/userSelectionForWf.vue'
import QcIterationListDialog from '@/components/materialMaster/qcIterationListDialog.vue'
import resourceSelectionComp from '@/components/form/resourceSelectionComp.vue'
import QcInspectionDialog from '@/components/materialMaster/qcInspectionDialog.vue'
import documentsComponent from '@/components/form/elements/documentsComponent.vue'
import errorBorder from '@/helper/formValidation/errorBorder'
import { getWorkflowUserMappings } from './wfInstanceEditHelper'
import { GetFormValueMap } from '@/helper/formValue.js'

export default {
  name: 'WorkflowDetailsPanel',
  components: {
    DOCUMENTS_COMPONENT: documentsComponent,
    customDropdown,
    Avatar,
    modal,
    UserSelectionForWf,
    resourceSelectionComp,
    QcInspectionDialog,
    QcIterationListDialog
  },
  props: {
    formId: {
      type: String,
      default: null
    },
    panelStyle: {
      type: String,
      default: 'alternate'
    },
    formCreatedBy: {
      type: String,
      default: null
    },
    wfInstanceId: {
      type: String,
      required: true
    },
    formStatus: {
      type: Number,
      default: null

    },
    formTypeId: {
      type: Number,
      default: null
    },
    formTemplateTypeId: {
      type: Number,
      default: null
    },
    documentField: {
      type: Object,
      default: null
    },
    selectedMaterial: {
      type: Object,
      default: () => ({ name: '', number: null })
    },
    showUpdateFormBtn: {
      type: Boolean,
      default: false
    },
    feature: {
      type: Number,
      default: config.CORE_FEATURES.FORMS
    },
    Status: {
      type: Number
    },
    folderId: {
      type: String
    }
  },
  filters: {
    genericFormatDate,
    statusfomat (value) {
      if (!value) return ''
      return value.replace(/_/g, ' ')
    },
    getQCStatusName (value) {
      if (!value) return ''
      else if (value === config.FORM_STATE_MAP.APPROVED) return 'Approved'
      else if (value === config.FORM_STATE_MAP.REJECTED) return 'Rejected'
      else if (value === config.FORM_STATE_MAP.HOLD) return 'Hold'
      else if (value === config.FORM_STATE_MAP.IN_PROGRESS) return 'In Progress'
    }
  },
  data () {
    return {
      config: config,
      workflowData: {},
      cancelReason: '',
      cancelWorkflowModal: false,
      selectedNextAction: null,
      nextStepData: {},
      existingUsers: null,
      selectedUserGroup: [],
      wFstepUsers: [], // this is used to store the users selected in the workflow step
      wFstepUsersDelete: [],
      formattedIndependentUsers: [],
      formattedIndependentUsersExceededCount: 0,
      selectedResources: [],
      availableResources: [],
      instanceStepDocs: [],
      openResourceItemModal: false,
      showQCDialog: false,
      showQCHistoryDialog: false,
      stepHistory: [],
      qcData: {},
      files: [],
      newFiles: [],
      existingFiles: [],
      formValueData: {},
      templateName: ''

    }
  },
  computed: {
    ...mapGetters(['user', 'isOnProjectLevel', 'tenantUsersList', 'currentProject', 'tenantList']),
    ...mapGetters(['isExternalCollaborator']),
    workflowTemplateName () {
      return this.workflowData?.workflow_version?.workflow_template?.name || this.templateName || '--'
    },
    formattedDuration () {
      const duration = `${this.workflowData?.workflow_stage?.duration}` // converting into string is to handle if duration comes as zero
      const durationType = this.workflowData?.workflow_stage?.duration_type
      if (!duration || !durationType) return '--'

      return this.formatDuration(duration, durationType)
    },
    nextTransitionData () {
      if (!this.workflowData?.workflow_stage?.qc_parent_step_id) {
        return this.workflowData.workflow_stage?.next_transition
      } else if (this.workflowData?.workflow_stage?.qc_parent_step_id && this.workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status === config.FORM_STATE_MAP.REJECTED) {
        return this.workflowData.workflow_stage?.next_transition.filter(item => item.next_workflow_stage.id === this.workflowData.workflow_stage?.qc_parent_step_id)
      } else if (this.workflowData?.workflow_stage?.qc_parent_step_id && this.workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status === config.FORM_STATE_MAP.APPROVED) {
        return this.workflowData.workflow_stage?.next_transition.filter(item => item.next_workflow_stage.id !== this.workflowData.workflow_stage?.qc_parent_step_id)
      } else { return this.workflowData.workflow_stage?.next_transition }
    },
    selectedNextActionObj () {
      return (
      this.workflowData.workflow_stage?.next_transition?.find(
        a => a.id === this.selectedNextAction
      ) || { id: -1, name: 'Select' }
      )
    },
    showNextAction () {
      if (!this.workflowData.editInstance) return false
      else if (this.workflowData?.state_value?.name === config.WORKFLOW_STATE_NAMES.COMPLETED || this.workflowData?.state_value?.name === config.WORKFLOW_STATE_NAMES.REJECTED) { return false } else if (!this.workflowData.workflow_stage?.end_step && !this.workflowData?.workflow_stage?.qc_parent_step_id) {
        return true
      } else if (!this.workflowData.workflow_stage?.end_step && this.workflowData?.workflow_stage?.qc_parent_step_id && [config.FORM_STATE_MAP.APPROVED, config.FORM_STATE_MAP.REJECTED].includes(this.workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status)) {
        return true
      } else if (this.workflowData.workflow_stage?.end_step && this.workflowData.workflow_stage?.qc_parent_step_id && config.FORM_STATE_MAP.REJECTED === this.workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status) {
        return true
      } else {
        return false
      }
    },
    showCancelButton () {
      return this.workflowData.state_value?.name === 'ONGOING' && this.formTypeId !== this.config.FORM_TEMPLATE_TYPE.JOF &&
      (this.user.tenantLevelRole === 'ADMIN' || this.user.userId === this.formCreatedBy || (this.isOnProjectLevel && this.user.projectLevelRole === 'ADMIN'))
    },
    showFinishWf () {
      if (this.workflowData.workflow_stage?.end_step && this.workflowData.workflow_stage?.qc_parent_step_id && config.FORM_STATE_MAP.APPROVED === this.workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status) {
        return true
      } else if (this.workflowData.workflow_stage?.end_step && !this.workflowData.workflow_stage?.qc_parent_step_id) {
        return true
      }
      return false
    },
    showWfSaveBtn () {
      if (this.workflowData.state_value?.name === 'ONGOING' && this.workflowData?.editInstance) {
        if (this.workflowData.workflow_stage?.end_step && this.workflowData?.workflow_stage?.resource_group && this.formTypeId === config.FORM_TEMPLATE_TYPE.JOF) {
          return true
        } else if (!this.workflowData.workflow_stage?.end_step && this.formTypeId === config.FORM_TEMPLATE_TYPE.JOF) {
          return true
        } else if (this.workflowData.workflow_stage?.end_step && this.formTypeId === config.FORM_TEMPLATE_TYPE.JOF && this.workflowData?.workflow_stage?.current_step_transition_history?.[0]?.qc_form?.status === config.FORM_STATE_MAP.REJECTED) {
          return true
        } else if (this.feature === config.CORE_FEATURES.TENANT && !this.workflowData.workflow_stage?.end_step) {
          return true
        } else if (this.feature === config.CORE_FEATURES.MATERIAL && !this.workflowData.workflow_stage?.end_step) {
          return true
        } else if (this.feature === config.CORE_FEATURES.DOCUMENTS && !this.workflowData.workflow_stage?.end_step) {
          return true
        } else if (this.feature === config.CORE_FEATURES.BOM && !this.workflowData.workflow_stage?.end_step) {
          return true
        }
      }
      return false
    },
    showAddResourceItem () {
      return (this.workflowData.stepAssigneeCount > 0 || this.workflowData.workflow_instance_steps[0]?.instance_step_resources?.length > 0) &&
             this.workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0 &&
             this.selectedResources.length === 0 &&
             this.workflowData.editInstance
    },
    showChildTenants () {
      if (this.nextStepData.end_step && this.nextStepData.trigger_actions.some(item => item.form_template_id)) {
        return false
      }
      return true
    },
    showUserSelectionComp () {
      return !this.isExternalCollaborator &&
        this.selectedNextAction &&
        this.existingUsers !== null &&
        (
          this.feature === config.CORE_FEATURES.FORMS ||
          this.feature === config.CORE_FEATURES.DOCUMENTS ||
          this.feature === config.CORE_FEATURES.BOM ||
          this.feature === config.WORKFLOW_SUB_CATE.LIFECYCLE
        )
    },
    getStates () {
      return config.STATE_MAP[this.Status] === 'CHECKOUT'
    }
  },
  async mounted () {
    if (this.formId) {
      await this.getFormData()
    }
    await this.getWorkFlowStepData()
    this.fetchAvailableResources()
    this.addPanelBasedWidth()
  },
  methods: {
    async getFormData (form) {
      this.templateId = this.$route.params.templateId
      this.templateName = this.$route.params.templateName
      const updatedFormId = form ? form.id : this.$route.params.formId
      this.loading = true
      this.loadEditForm = true
      const res = await GetFormDataByFormId(updatedFormId, this.isOnProjectLevel, this.isExternalCollaborator)
      this.formData = res.core_forms_by_pk
      this.formValueData = GetFormValueMap(res.core_forms_by_pk)
    },
    formatDuration (duration, durationType) {
      if (durationType === 1) {
        return `${duration} ${duration === 1 ? 'Day' : 'Days'}`
      }

      if (durationType === 2) {
        const days = Math.floor(duration / 24)
        const hours = duration % 24

        if (days > 0 && hours > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'} ${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        } else if (days > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'}`
        } else {
          return `${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        }
      }

      if (durationType === 3) {
        const days = Math.floor(duration / (60 * 24))
        const hours = Math.floor((duration % (60 * 24)) / 60)
        const minutes = duration % 60

        const parts = []
        if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`)
        if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`)
        if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'Min' : 'Mins'}`)

        return parts.length > 0 ? parts.join(' ') : '0 Mins'
      }

      return `${duration} ${this.config.DURATION_TYPE[durationType]}`
    },
    formatFileSize (size) {
      const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
    },
    getUserTooltip (user) {
      return `${user.first_name} ${user.last_name}`
    },
    getStatusClass (status) {
      const statusClasses = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: 'in-progress',
        [config.FORM_STATE_MAP.APPROVED]: 'approved',
        [config.FORM_STATE_MAP.REJECTED]: 'rejected',
        [config.FORM_STATE_MAP.HOLD]: 'hold'
      }
      return statusClasses[status?.value] || 'in-progress'
    },
    getStatusIcon (status) {
      const statusIcons = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: '✓',
        [config.FORM_STATE_MAP.APPROVED]: '✓',
        [config.FORM_STATE_MAP.REJECTED]: '✗',
        [config.FORM_STATE_MAP.HOLD]: '⏸'
      }
      return statusIcons[status?.value] || '✓'
    },
    onNextActionSelect (item) {
      this.$emit('nextActionSelect', item)
      this.selectedNextAction = item.id
      this.nextAction()
    },
    getWorkFlowStepData (wfInstanceId = this.wfInstanceId) {
      const loader = new Loader()
      loader.show()
      return new Promise((resolve, reject) => {
        if (!wfInstanceId) {
          resolve()
        }
        workflowDataBasedOnInstanceId(wfInstanceId, this.isExternalCollaborator).then((res) => {
          this.formattedIndependentUsers = []
          this.formattedIndependentUsersExceededCount = 0
          this.wFstepUsersDelete = []
          this.wFstepUsers = []
          this.workflowData = res.workflow_instances_by_pk
          this.workflowData.editInstance = this.getInstanceEditPermission(this.workflowData)
          if (this.workflowData.workflow_instance_steps?.length) {
            if (this.workflowData.workflow_instance_steps[0].instance_step_assignees?.length < 3) {
              this.formattedIndependentUsers = this.workflowData.workflow_instance_steps[0].instance_step_assignees
            } else {
              this.formattedIndependentUsers = this.workflowData.workflow_instance_steps[0].instance_step_assignees?.slice(0, 3)
              this.formattedIndependentUsersExceededCount = this.workflowData.workflow_instance_steps[0].instance_step_assignees.length - 3
            }
            if (this.workflowData.workflow_instance_steps[0].instance_step_resources?.length > 0) {
              const resources = this.workflowData.workflow_instance_steps[0].instance_step_resources
                .filter(item => item.workflow_step_id === this.workflowData.workflow_stage.id)

              this.selectedResources = resources.map(resource => ({
                value: resource.resource_id, // factory_resource_association ID
                label: resource?.factory_resource_instance?.name,
                resource_id: resource?.resource_id
              }))
            } else {
              this.selectedResources = []
            }
          }
          this.existingFiles = this.workflowData.workflow_instance_steps?.[0]?.core_attachments.map(file => ({
            ...file,
            size: this.formatFileSize(file.file_size),
            status: 'uploaded'
          }))
          this.fileSize = this.files?.length
          this.getstepDocsData(wfInstanceId, this.workflowData.workflow_instance_steps[0]?.step_id)
          loader.hide()
          resolve()
        }).catch((err) => {
          loader.hide()
          console.log(err)
        })

          .finally(() => {
            resolve()
          })
      })
    },
    closeWorkflowModal () {
      this.cancelWorkflowModal = false
      this.cancelReason = ''
    },
    cancelWorkflow () {
      if (!this.cancelReason) {
        alert('Please provide a reason for cancellation')
        return
      }
      const loader = new Loader()
      loader.show()
      const body = {
        input: {
          metadata: {
            comment: this.cancelReason
          },
          cancel_workflow: true,
          history_id: this.workflowData.transition_history[0]?.id,
          instance_id: this.wfInstanceId
        }
      }
      updateWorkFlowActionApi(body).then((response) => {
        loader.hide()
        success('Workflow cancelled successfully')
        this.closeWorkflowModal()
        this.$emit('workflowCancelled', response?.message)
        if (this.feature === config.CORE_FEATURES.TENANT) {
          this.$emit('workflowCancelled', response?.message)
          this.getWorkFlowStepData()
          if (this.formId) {
            this.getFormData()
          }
        } else if (this.feature === config.CORE_FEATURES.MATERIAL) {
          this.$emit('material-workflow-cancelled')
        } else if (this.feature === config.CORE_FEATURES.DOCUMENTS) {
          // Documents flow is typically inside a modal (e.g. file card),
          // so we should stay on the same route and let parent close modal.
        } else if (this.feature === config.CORE_FEATURES.BOM) {
          // BOM flow is also opened in-page via modal; keep user on same BOM route.
        } else {
          this.$router.push({ name: 'ViewForm', params: { formId: this.formId } })
        }
      }).catch(() => {
        loader.hide()
        alert('Failed to cancel workflow')
      })
    },
    getInstanceEditPermission (workflowData) {
      if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
        return true
      } else if (workflowData?.workflow_stage?.core_user_group?.core_user_group_members.some(item => item.user_id === this.user.userId)) {
        return true
      } else if (workflowData?.workflow_instance_steps[0]?.instance_step_assignees.some(item => item.user_id === this.user.userId)) {
        return true
      } else {
        return false
      }
    },
    getstepDocsData (instanceId, currentStepId) {
      if (!instanceId || !currentStepId) {
        return
      }
      getAllStepDocsExceptGivenStep({ currentStepId, instanceId }).then(res => {
        this.instanceStepDocs = res.workflow_instance_steps
      })
    },
    nextAction () {
      getNextStepWithTransitionId(this.selectedNextAction).then(res => {
        this.nextStepData = { currentTansName: res.workflow_transitions_by_pk?.name, ...res.workflow_transitions_by_pk.next_workflow_stage }
        this.getStepAssigneesData()
      }).catch((err) => {
        console.log(err)
      })
    },
    getStepAssigneesData () {
      const loader = new Loader()
      loader.show()
      getStepAssignees(this.wfInstanceId, this.nextStepData.id).then(res => {
        const users = res.instance_step_assignees.map((item) => {
          return {
            user_id: item.user_id,
            target_tenant_id: item.target_tenant_id
          }
        })
        this.existingUsers = null
        this.existingUsers = [...users]
        loader.hide()
      })
    },
    handleUserSelection (data) {
      this.wFstepUsers = data.value.insert
      this.wFstepUsersDelete = data.value.delete
    },
    addResourceItem () {
      this.openResourceItemModal = true
    },
    selectResource (data) {
      this.selectedResource = data
      this.openResourceItemModal = false
    },
    onQCSave (inspectionData) {
      this.getWorkFlowStepData()
      this.showQCDialog = false
      this.qcData = {}
    },
    closeQCDialog () {
      this.showQCDialog = false
    },
    closeQCHistoryDialog () {
      this.showQCHistoryDialog = false
    },
    viewInspection (qcData) {
      this.qcData = {
        qcformId: qcData.qcformId,
        qcTemplateId: qcData.qcTemplateId,
        stepName: qcData.operation,
        instance_id: this.wfInstanceId,
        step_id: this.workflowData.workflow_stage.id,
        edit: false
      }
      this.showQCDialog = true
      this.showQCHistoryDialog = false
    },
    updateQcform (qcData) {
      this.qcData = {
        qcformId: qcData.qcformId,
        qcTemplateId: qcData.qcTemplateId,
        stepName: qcData.operation,
        instance_id: this.wfInstanceId,
        step_id: this.workflowData.workflow_stage.id,
        edit: true
      }
      this.showQCDialog = true
      this.showQCHistoryDialog = false
    },
    async fillQC (mm, index) {
      this.qcData = {
        qcformId: this.workflowData?.workflow_stage?.current_step_transition_history[0]?.form_id,
        qcTemplateId: this.workflowData?.workflow_stage?.qc_form_template_id,
        stepName: this.workflowData?.workflow_stage?.name,
        instance_id: this.wfInstanceId,
        step_id: this.workflowData.workflow_stage.id,
        edit: this.workflowData.editInstance
      }
      const loader = new Loader()
      loader.show()
      try {
        const stepHistory = await this.getWorkflowHistory()
        this.stepHistory = stepHistory.message.data
        loader.hide()
        // this is condition if the qc has been rejected and we are coming to fill the qc again then need to show the qc history qc history modal
        if (stepHistory.message.data.length >= 2) {
          this.handleQCHistory()
          return
        }
      } catch (error) {
        console.log(error)
        loader.hide()
        alert('Something went wrong')
      }
      // Show QC Inspection Dialog directly
      this.showQCDialog = true
    },
    getWorkflowHistory () {
      return getWfStepHistory(
        this.qcData.instance_id,
        this.qcData.step_id
      )
    },
    handleQCHistory (qcData) {
      this.showQCDialog = false
      this.showQCHistoryDialog = true
    },
    async onFilePicked (event) {
      const selectedFiles = event.target.files
      const defaultTenantId = '' // Replace or map from Vuex if needed

      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i]
        const fileType = file?.name.split('.').pop()
        const formattedSize = this.formatFileSize(file.size)

        // Temporary file object with uploading status
        const fileEntry = {
          file_name: file?.name,
          file_type: fileType,
          file_size: file.size,
          status: 'uploading'
        }

        // Add temporarily while uploading
        this.newFiles.push(fileEntry)

        try {
          // Step 1: Get signed URL
          const { url } = await generateS3SubmittingUrl({
            tenantId: defaultTenantId,
            feature: 'form', // adjust as needed
            featureId: 'formDocument', // adjust as needed
            fileName: file?.name
          })

          // Step 2: Upload to S3
          await fetch(url, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': file.type
            }
          })

          // Step 3: Extract blob key
          const blobKey = url.split('?')[0].split('.com/').pop()

          // Step 4: Replace entry with final attachmentObj
          this.$set(this.newFiles, this.newFiles.length - 1, {
            blob_key: blobKey,
            file_name: file?.name,
            file_type: fileType,
            file_size: file.size,
            size: formattedSize, // Optional if used in UI
            status: 'uploaded'
          })
        } catch (err) {
          console.error('Upload failed:', err)
          // Mark status as failed
          this.$set(this.files, this.files.length - 1, {
            ...fileEntry,
            status: 'failed'
          })
        }
      }

      // Clear input so same file can be selected again
      this.$refs.fileInput.value = ''
    },
    handleInputChange (data) {
      this.metadataPayloadValueMap[data.field_id] = data.value
    },
    revisionFilesUploaded (data) {
      data[0].folder_id = this.folderId
      this.newFiles = data
    },
    triggerFilePicker () {
      this.$refs.fileInput.click()
    },
    async updateWorkFlowAction (closeWFTform, stepUsers, deleteUsers) {
      try {
        this.newFiles.map(file => {
          file.status = undefined
          file.size = undefined
        })
        if (this.workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0) {
          await this.updateResourcesForStep()
        }
        const body = {
          input: {
            metadata: {
              attachments: this.newFiles
            },
            close_workflow: closeWFTform ? true : undefined,
            history_id: this.workflowData.transition_history[0].id,
            instance_id: this.wfInstanceId,
            action_taken: closeWFTform ? null : this.selectedNextAction,
            next_step_assignees: this.wFstepUsers.length ? stepUsers : undefined,
            delete_step_assignees: deleteUsers?.length ? deleteUsers : []
          }
        }
        const response = await updateWorkFlowActionApi(body)
        if (response?.message?.message !== 'History updated successfully') {
          throw new Error('Failed to update workflow action')
        } else if (response?.message?.message === 'History updated successfully' && this.feature === config.WORKFLOW_SUB_CATE.LIFECYCLE && response?.message?.trigger_action_updates) {
          // status for material and state for files and bom
          if (response?.message?.trigger_action_updates?.status) {
            this.$emit('workflowHistoryUpdated', response?.message?.trigger_action_updates?.status)
          } else if (response?.message?.trigger_action_updates?.state) {
            this.$emit('workflowHistoryUpdated', response?.message?.trigger_action_updates?.state)
          }
        }
        return response
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async finishWorkflow () {
      // Validate resources when finishing workflow
      if (this.workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0 &&
          !this.selectedResources?.length) {
        alert('Please select resources before finishing workflow')
        return
      }

      // Validate file upload if mandatory
      if (this.workflowData?.workflow_stage?.trigger_actions &&
          this.workflowData?.workflow_stage?.trigger_actions[0]?.trigger_timing === 'on_start' &&
          this.workflowData?.workflow_stage?.trigger_actions[0]?.mandatory === true) {
        if (![...this.newFiles, ...this.existingFiles].length) {
          alert('File upload is mandatory before finishing workflow!')
          return
        }
      }

      // Check if files are still uploading
      const isUploading = this.newFiles.some(file => file.status === 'uploading')
      if (isUploading) {
        alert('Please wait for all files to finish uploading before finishing workflow.')
        return
      }
      // All validations passed, emit the event
      this.$emit('finishWorkflow')
    },
    async updateWorkflowMaterial (closeWFTform = null) {
      // Check if just saving resources (no next action, no closing workflow)
      if (!this.selectedNextAction && !closeWFTform && this.workflowData?.workflow_stage?.workflow_step_resources_associations?.length) {
        const loader = new Loader()
        loader.show()
        await this.updateResourcesForStep()
        loader.hide()
        success('Successfully updated resources')
        return
      }
      // Validate resources when moving to next step or finishing workflow
      if ((this.selectedNextAction || closeWFTform) &&
          this.workflowData?.workflow_stage?.workflow_step_resources_associations?.length > 0 &&
          !this.selectedResources?.length) {
        alert('Please select resources before proceeding')
        return
      }

      // Validate next action is selected when not just saving
      if (!this.selectedNextAction && !closeWFTform) {
        alert('No next action selected, cannot proceed')
        return
      }

      let error = false
      if (this.workflowData?.workflow_stage?.trigger_actions && this.workflowData?.workflow_stage?.trigger_actions[0]?.trigger_timing === 'on_start' && this.workflowData?.workflow_stage?.trigger_actions[0]?.mandatory === true && this.selectedNextAction) {
        if (![...this.newFiles, ...this.existingFiles].length && this.workflowData?.workflow_stage?.trigger_actions?.[0]?.mandatory === true) {
          alert('File upload mandatory before next action!')
          error = true
        }
      }
      const isUploading = this.newFiles.some(file => file.status === 'uploading')
      if (isUploading) {
        alert('Please wait for all files to finish uploading before saving.')
        error = true
      }
      if (this.selectedNextAction && this.feature !== config.CORE_FEATURES.MATERIAL && this.feature !== config.CORE_FEATURES.TENANT && !this.nextStepData.core_user_group?.name && !this.wFstepUsers?.length) {
        errorBorder('multiSelectinput', true)
        alert('Please select users for the next step')
        error = true
      }
      if (error) return
      const loader = new Loader()
      loader.show()
      try {
        if ((this.selectedNextAction || closeWFTform || this.newFiles.length || this.wFstepUsers.length) && this.currentStatus !== config.FORM_STATE_MAP.DRAFT) {
          // closeWFTform is used to close the form if there is a workflow template associated with it
          const {
            insertUsers = [],
            deleteUsers = []
          } = !this.isExternalCollaborator && getWorkflowUserMappings({
            parentInstanceId: this.parentInstanceId,
            workflowData: this.workflowData,
            wFstepUsers: this.wFstepUsers,
            existingUsers: this.existingUsers,
            nextStepId: this.nextStepData.id,
            wfInstanceId: this.wfInstanceId,
            selectedStartingStep: this.selectedStartingStep,
            currentStatus: this.currentStatus,
            FORM_STATE_MAP: config.FORM_STATE_MAP
          })
          await this.updateWorkFlowAction(closeWFTform, insertUsers, deleteUsers)
          this.getWorkFlowStepData()
          this.$emit('afterWFaction', closeWFTform)
          this.goback()
        }
        success('Successfully updated workflow')
        this.$emit('goBack')
      } catch (error) {
        console.log(error)
        alert('Failed to update workflow action')
      } finally {
        loader.hide()
      }
    },
    async fetchAvailableResources () {
      if (!this.workflowData?.workflow_stage?.workflow_step_resources_associations?.length) {
        this.availableResources = []
        return
      }

      const resourceIds = this.workflowData.workflow_stage.workflow_step_resources_associations
        .map(assoc => assoc.resource_id)
      if (!this.formData?.factory_id || resourceIds.length === 0) {
        this.availableResources = []
        return
      }

      try {
        const res = await getFactoryResourceAssociations(
          this.formData.factory_id,
          resourceIds,
          this.isOnProjectLevel,
          ['IDLE', 'RUNNING']
        )

        this.availableResources = res.factory_resource_association.map(item => ({
          value: item.id,
          label: item.name,
          resource_id: item.resource_id
        }))
      } catch (error) {
        console.error('Error fetching factory resources:', error)
        this.availableResources = []
      }
    },
    selectResources (selectedArray) {
      this.selectedResources = selectedArray
      this.openResourceItemModal = false
    },
    async updateResourcesForStep () {
      if (!this.selectedResources || this.selectedResources.length === 0) {
        return
      }

      // Always send the full list of selected resources (value is the factory_resource_association id)
      const resourceBody = this.selectedResources.map(resource => ({
        instance_id: this.wfInstanceId,
        step_id: this.workflowData.workflow_stage.id,
        resource_id: resource.value
      }))

      return updateResourceGroup(resourceBody, this.isOnProjectLevel)
    },
    resourceGroupUpdate () {
      // Deprecated - kept for backward compatibility
      return this.updateResourcesForStep()
    },
    addResourceItemModal () {
      this.openResourceItemModal = true
    },
    goback () {
      this.workflowData = {}
      this.selectedNextAction = null
      this.nextStepData = {}
      this.stepWithNoUsers = {}
      this.selectedUserGroup = []
      this.instanceStepDocs = []
      this.$emit('goBack')
    },
    addPanelBasedWidth () {
      if (this.panelStyle !== 'default') {
        if (window.innerWidth < 1200) {
          document.getElementsByClassName('activeStep-container')[0].style.maxWidth = '563px'
        } else {
          document.getElementsByClassName('activeStep-container')[0].style.maxWidth = '823px'
        }
      }
    }
  },
  watch: {
    async wfInstanceId () {
      if (this.formId) {
        await this.getFormData()
      }
      await this.getWorkFlowStepData()
      this.fetchAvailableResources()
    }
  }
}
</script>

<style lang="scss" scoped >
 .step-name-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 75%;
}
.btn-2 {
  font-size: var(--text-s);
  width: fit-content;
  height: fit-content;
}
.status-tag {
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  display: inline-block;
  min-width: 100px;
  text-align: center;
}
.not-started {
  background-color: rgba(255, 0, 0, 0.1);
  color: purple;
  max-width: 150px;
}

.completed {
  background-color: rgba(0, 128, 0, 0.1);
  color: green;
  max-width: 150px;
}

.ongoing {
  background-color: rgba(255, 165, 0, 0.1);
  color: orange;
  max-width: 150px;
}

.cancelled {
  background-color: rgba(198, 39, 52, 0.1);
  color: red;
}
.activeStep {
  padding: 16px 20px 20px;
  // background: #fff;
  // border-radius: 6px;
  // box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 10px;
  &-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: -webkit-fill-available;
    overflow: auto;
    background: #fff;
    border-radius: 6px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    &--flat {
    padding: 0;
  }
    & .cancel-wf-btn{
      background-color: #d1d5db;
    }
    &--flat {
      box-shadow: none;
    }
  }
  @media (max-height: 500px) {
    max-height: 455px;
    overflow-y: scroll;
  }
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  & .step-name {
  font-size: var(--text-4xl);
  font-weight: 600;
  max-width: 250px;
}
}

.dept {
  font-size: var(--text-s);
  color: #696969;
  font-weight: 400;
}
.border {
  // box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
  border-top: 1px solid #DCDCDC;
}
.date-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.label-2 {
  font-size: var(--text-xs2);
  color: #696969;
  // font-weight: 500;
  margin-bottom: 4px;
}

.date-block {
  display: flex;
  flex-direction: column;
  font-size: var(--text-base);
}

.date-detail {
  margin-right: 2px;
  font-size: var(--text-s);
  color: #696969;
  margin-bottom: 2px;
}
.date-value {
  font-size: var(--text-s);
}

.duration-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.duration-value {
  // color: #696969;
  font-size: var(--text-s);
  font-weight: 500;
  // margin-top: -5px;
}

.upload-row {
  min-height: 90px;
  display: flex;
  gap: 15px;
  // padding-top: 16px;
  // align-items: flex-start;
  // border-top: 1px solid #ccc;
  // margin-top: 12px;
}

.upload-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #ccc;
  padding-right: 10px;
  width: 25%;
  height: 90px;
  margin-right: 10px;
  text-align: center;
  align-items: center;
}
.upload-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin-bottom: 8px;
}

.uploaded-files-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.uploaded-header {
  font-weight: 500;
  margin-bottom: 8px;
  font-size: var(--text-xs2);
  white-space: nowrap;
  color: #696969;
  font-weight: 500;
}

.uploaded-list {
  overflow-y: auto;
  max-height: 120px;
  padding-right: 8px;
}
.no-files {
  font-size: var(--text-xs1);
// display: flex;
// align-items: center;
// justify-content: center;
height: 120px;
padding-right: 8px;
}

.uploaded-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  font-size: var(--text-base);
  color: #333;
&  .step-name{
   white-space: nowrap;
  font-size: .85em;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30%;
}
}

.file-name {
  font-size: var(--text-xs1);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.file-status {
  white-space: nowrap;
  font-size: var(--text-m);
  color: #888;
}

.loader {
  width: 14px;
  height: 14px;
  border: 2px solid #ccc;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
}
.error-text {
  color: red;
  font-size: var(--text-xs1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.next-action-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.next-action-header .label {
  font-weight: 500;
  font-size: var(--text-s);
  white-space: nowrap;
  margin-right: 12px;
}

.next-action-line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
  margin-top: 1px;
}

.next-action-desc {
  font-size: var(--text-xs2);
  color: #666;
}

.next-action-select {
  // width: fit-content;
  // padding: 6px 10px;
  font-size: var(--text-base);
  border: 1px solid #ccc;
  border-radius: 4px;
}
.upload-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-header .label {
  font-weight: 500;
  font-size: var(--text-s);
  white-space: nowrap;
  margin-right: 12px;
}

.upload-line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
  margin-top: 1px;
}

.upload-desc {
  font-size: var(--text-xs2);
  color: #666;
  margin: 0 0 8px 0;
}

.upload-select {
  // width: fit-content;
  // padding: 6px 10px;
  font-size: var(--text-base);
  border: 1px solid #ccc;
  border-radius: 4px;
}
.tab-body-parent{
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: -webkit-fill-available;
    overflow: auto;
}
.resource-item{
  display: flex;
  align-items: center;
gap: 10px;
&-btn2{
  padding: 0px 4px;
border: 1px solid #ccc;
border-radius: 2px;
font-size: var(--text-base);
border-radius: 3px;
border-width: 0px;
cursor: pointer;
background: transparent;
&:hover{
  border-width:1px;
}
&:active{
  transform: scale(0.9);
}
}
   &-btn{
padding: 0px 4px;
border: 1px solid #ccc;
border-radius: 4px;
font-size: var(--text-base);
border-radius:3px;
cursor: pointer;
background: transparent;
&:hover{
background: #000000;
border-color: #ccc;
color:white;
}
&:active{
  transform: scale(0.9);
}
   }
}
.fill-qc-btn {
  background: #f5f5f5;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: var(--text-s);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(158, 158, 158, 0.3);
  box-shadow: 0 1px 2px rgba(102, 126, 234, 0.2);

  &:hover {
    background: #e8e8e8;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(211, 219, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(189, 191, 197, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(189, 191, 197, 0.3);
  }
}
        .status-display {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 1px 3px;
          font-size: var(--text-s);
          background: none;
          color: #000000;
          font-weight: 500;
          height: auto;
          width: auto;
          // border: 1px solid rgb(210, 193, 193);
          border-radius: 4px;
          margin-left: 5px;

          .status-icon {
            .status-circle {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;

              .status-symbol {
                color: white;
                font-size: var(--text-xs1);
                font-weight: bold;
                line-height: 1;
              }

              &.in-progress, progress {
                background-color: #ff7b00; // Green
              }

              &.approved {
                background-color: #16a34a; // Darker green
              }

              &.rejected {
                background-color: #dc2626; // Red
              }

              &.hold {
                background-color: #eab308; // Yellow
              }
            }
          }

          .status-text {
            color: #000000;
            font-size: var(--text-s);
            font-weight: 400;
          }
        }

        .status-buttons {
          display: flex;
          gap: 8px;

          .status-btn {
            padding: 6px 12px;
            border-radius: 4px;
            font-size: var(--text-s);
            border: none;
            cursor: pointer;
            transition: all 0.2s;
            background-color: #f3f4f6;
            color: #374151;

            &:hover {
              background-color: #e5e7eb;
            }

            &.active {
              background-color: #111827;
              color: white;
            }

            &.green {
              background-color: #dcfce7;
              color: #166534;
              border: 1px solid #bbf7d0;

              &:hover {
                background-color: #bbf7d0;
              }

              &.active {
                background-color: #16a34a;
                color: white;
                border-color: #16a34a;
              }
            }

            &.red {
              background-color: #fef2f2;
              color: #991b1b;
              border: 1px solid #fecaca;

              &:hover {
                background-color: #fecaca;
              }

              &.active {
                background-color: #dc2626;
                color: white;
                border-color: #dc2626;
              }
            }

            &.yellow {
              background-color: #fefce8;
              color: #a16207;
              border: 1px solid #fde047;

              &:hover {
                background-color: #fde047;
              }

              &.active {
                background-color: #eab308;
                color: white;
                border-color: #eab308;
              }
            }
            &.orange {
              background-color: #fefce8;
              color: #ff7b00;
              border:1px solid #edc7a3;

              &:hover {
                background-color: #ff7b0062;
              }

              &.active {
                background-color: #ff7b00;
                color: white;
                border-color:#ff7b00;
              }
            }
                &.no-hover {
      background-color: #e5e7eb !important;
      color: #9ca3af !important;
      border: 1px solid #d1d5db !important;
      cursor: not-allowed !important;

      &:hover {
        background-color: #e5e7eb !important;
      }
    }
          }
        }
        .statusBorder{
          &-approved{
            border: 1px solid #16a34a;
          }
          &-rejected{
            border: 1px solid #dc2626;
          }
          &-hold{
            border: 1px solid #eab308;
          }
          &-in-progress{
            border: 1px solid #ff7b00;
          }
        }

.resources-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  flex-grow: 1;
}

.resource-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background-color: var(--brand-light-color);
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  font-size: 0.85rem;
  white-space: nowrap;
}

.resource-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
